<h1 i18n [attr.data-testid]="'company-settings-title'">組織設定</h1>

<mat-accordion multi [attr.data-testid]="'company-settings-accordion'">
  <mat-expansion-panel
    expanded="true"
    [attr.data-testid]="'basic-settings-panel'"
    >
    <mat-expansion-panel-header>
      <mat-panel-title i18n [attr.data-testid]="'basic-settings-title'">
        基本設定
      </mat-panel-title>
    </mat-expansion-panel-header>
    <form [formGroup]="companyForm" [attr.data-testid]="'company-form'">
      <mat-form-field legacyAppearance>
        <mat-label i18n [attr.data-testid]="'company-id-label'"
          >組織編號</mat-label
          >
          <input
            matInput
            formControlName="id"
            [attr.data-testid]="'company-id-input'"
            />
        </mat-form-field>
        <mat-form-field legacyAppearance>
          <mat-label i18n [attr.data-testid]="'company-name-label'"
            >組織名稱</mat-label
            >
            <input
              matInput
              formControlName="name"
              [attr.data-testid]="'company-name-input'"
              />
          </mat-form-field>
        </form>
      </mat-expansion-panel>

      <mat-expansion-panel
        expanded="true"
        [attr.data-testid]="'property-settings-panel'"
        >
        <mat-expansion-panel-header>
          <mat-panel-title i18n [attr.data-testid]="'property-settings-title'">
        屬性設定
      </mat-panel-title>
        </mat-expansion-panel-header>
        <form [formGroup]="propertyForm" [attr.data-testid]="'property-form'">
          @for (config of propertyConfigs; track config) {
            <mat-form-field legacyAppearance>
              <mat-label [attr.data-testid]="'property-label-' + config.key"
                >{{ config.name }} {{ config.key }}</mat-label
                >
                <input
                  matInput
                  [formControlName]="config.key"
                  [attr.data-testid]="'property-input-' + config.key"
                  />
              </mat-form-field>
            }
          </form>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-divider [attr.data-testid]="'settings-divider'"></mat-divider>

      <div class="submit-wrap" [attr.data-testid]="'submit-container'">
        <button
          class="submit"
          mat-raised-button
          color="primary"
          [disabled]="companyForm.invalid || propertyForm.invalid || !!loadPercent"
          (click)="sendChange()"
          i18n
          [attr.data-testid]="'submit-button'"
          >
    確定修改
  </button>
      </div>

      @if (loadPercent) {
        <mat-progress-bar
          mode="indeterminate"
          [attr.data-testid]="'loading-progress-bar'"
          >
        </mat-progress-bar>
      }
